import React, { useState, useRef } from "react";
import ClosedLoopTree from "./ClosedLoopTree";

export default function ClosedLoopTreeOutgoing() {
  const data = {
    name: "Outgoing Transactions​​",
    value: 400,
    id: 1,
    children: [
      {
        name: "Own Bank",
        value: 100,
        id: 2,
        parent: 400,
      },
      {
        name: "Other Banks",
        value: 200,
        id: 3,
        parent: 400,
        children: [
          {
            name: "Mitra Korporat​",
            value: 150,
            id: 4,
            parent: 200,
            children: [
              {
                name: "Customer 1​",
                value: 100,
                id: 5,
                parent: 150,
                children: [
                  { name: "Transfer​", id: 6, value: 100, parent: 100 },
                ],
              },
              {
                name: "Customer 2",
                value: 50,
                id: 7,
                parent: 150,
                children: [{ name: "Transfer​", id: 8, value: 50, parent: 50 }],
              },
            ],
          },
          {
            name: "Within group / Intracompany",
            id: 9,
            value: 20,
            parent: 200,
          },
          { name: "Unclassified", id: 10, value: 30, parent: 200 },
        ],
      },
      {
        name: "Payment (Pembayaran & Billpayment)​​",
        value: 50,
        id: 11,
        parent: 400,
      },
      {
        name: "Tarik Cheq​​​",
        value: 25,
        id: 12,
        parent: 400,
      },
      {
        name: "Tarik Tunai​",
        value: 25,
        id: 13,
        parent: 400,
      },
    ],
  };
  return <ClosedLoopTree data={data} />;
}
